import $ from "jquery";
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import { services } from "../services/notificationService";
import { application } from "../application/application";

function init() {
    const personId = $("#signaturePersonId").val();
    const previewNode = document.querySelector("#signatureTemplate");
    previewNode.id = "";
    const previewTemplate = previewNode.parentNode.innerHTML;
    previewNode.parentNode.removeChild(previewNode);

    const myDropzone = Dropzone.forElement("#signatureUploader");

    myDropzone.options.addRemoveLinks = true;
    myDropzone.options.autoProcessQueue = false;
    myDropzone.options.disablePreview = true;
    myDropzone.options.parallelUploads = 100;
    myDropzone.options.uploadMultiple = true;
    myDropzone.options.previewTemplate = previewTemplate;
    myDropzone.options.previewsContainer = "#SignaturePreviewTemplateParent";
    myDropzone.options.acceptedFiles = ".jpg,.png";

    myDropzone.on("queuecomplete", function () {
        this.removeAllFiles();
    });

    myDropzone.on("error", function (file, response) {
        services.notificationService.error(response);
    });

    myDropzone.on("success", function (file, response) {
        $("#TablePartial").html(response);
    });

    myDropzone.on("addedfile", function (file) {
        if (this.files.length > 0) {
            $("#UploadBtn").show();
        }
        if (file.size > 50000) {
            alert("File is to large (" + file.size + ")");
            this.removeAllFiles();
            $("#UploadBtn").hide();
        }
    });

    myDropzone.on("removedfile", function () {
        if (this.files.length === 0) {
            $("#UploadBtn").hide();
        }
    });

    myDropzone.on("sending", function (file, xhr, formData) {
        formData.append("PersonId", personId);
    });

    myDropzone.on("complete", function () {
        const personId = $("#signaturePersonId").val();
        window.location.href = application.baseUrl + "/Person/index/" + personId;
    });

    $("#UploadBtn").click(function () {
        let isValid = true;

        $(".dz-preview").each(function (index, item) {
            $(this).find(".dz-error-message").hide();
            $(this).find(".js-val-error").text("");

        });

        if (isValid) {
            forms.disableSubmitButton();
            forms.showSpinner("Uploading...", false);
            myDropzone.processQueue();
        }
    });

    $("#signatureDeleteBtn").click(function () {
        forms.showSpinner("Removing signature...", false);
        const $form = $("#signatureDeleteSignature");
        const params = {
            contentType: dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            data: $form.serialize(),
            url: $form.attr("action"),
            successMsg: "Signature removed."
        };

        dataaccess.post(params)
            .done(function (result) {
                window.location.href = application.baseUrl + "/Person/index/" + personId;
            });
    });
}

export const personSignature = {
    init: init
};